export const QuizState = {
    SELECTION: 'selection',
    QUIZ: 'quiz',
    RESULTS: 'results',
}
